'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateYearValidator;
var _range = require('./range');
var _range2 = _interopRequireDefault(_range);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function generateYearValidator(min, max, message) {
  var currentYear = new Date().getFullYear();
  var minYear = min === 'current' ? currentYear : min;
  var maxYear = max === 'current' ? currentYear : max;
  return (0, _range2.default)(minYear, maxYear, message);
}